import React from "react";
import { FaWhatsapp, FaFacebookF, FaYoutube } from "react-icons/fa";
import "./FooterSection.css";

const FooterSection = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        <h3 className="footer-title">Taleemul Quran Academy</h3>

        <p className="footer-text">
          Spreading authentic Islamic knowledge based on the Qur’an and Sunnah.
        </p>

        <div className="footer-social">
          <a
            href="https://wa.me/8801XXXXXXXXX"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="WhatsApp"
          >
            <FaWhatsapp />
          </a>

          <a href="#" aria-label="Facebook">
            <FaFacebookF />
          </a>

          <a href="#" aria-label="YouTube">
            <FaYoutube />
          </a>
        </div>

        <div className="footer-bottom">
          © {new Date().getFullYear()} TaleemulQuranAcademy. All rights
          reserved.
        </div>
      </div>
    </footer>
  );
};

export default FooterSection;
